<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .toggles {
    display: grid;
    gap: utils.in_rem(10px);
  }
  h3 {
    margin-bottom: utils.in_rem(16px);
  }
</style>

<script>
  import SettingToggle from "../../../components/shared/SettingToggle.svelte";

  export let toggleSettings = [];
</script>

{#if toggleSettings?.length}
  <section>
    <h3>Flagged data removal</h3>
    <div class="toggles">
      {#each toggleSettings as setting (setting.key)}
        <SettingToggle {setting} />
      {/each}
    </div>
  </section>
{/if}
